import axios from "axios";
const API_BASE_URL = "https://api.dattamandir.com/api/v1/user"; // Base URL
// const API_BASE_URL = "http://localhost:9325/api/v1/user"; // Base URL
const API_KEY = "AppaBaba#2050"; // Replace with your actual API key

export const postDonationEntry = async (data) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/donation-entry`, data, {
      headers: {
        "api_key": API_KEY, // Adding API key in headers
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error posting donation entry:", error.response?.data || error);
    throw error;
  }
};

export const contactusEntry = async (data) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/contactus-entry`, data, {
      headers: {
        "api_key": API_KEY, // Adding API key in headers
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error posting contactus-entry:", error.response?.data || error);
    throw error;
  }
};

export const vidhiEntry = async (data) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/vidhi-entry`, data, {
      headers: {
        "api_key": API_KEY, // Adding API key in headers
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error posting contactus-entry:", error.response?.data || error);
    throw error;
  }
};
export const bhaktaParivarEntry = async (data) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/bhaktaparivar-entry`, data, {
      headers: {
        "api_key": API_KEY, // Adding API key in headers
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error posting contactus-entry:", error.response?.data || error);
    throw error;
  }
};
export const getDistrictdropdownList = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/get-districts`, {
      headers: {
        "api_key": API_KEY, // same key
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching district-list:", error.response?.data || error);
    throw error;
  }
};
